import { Col } from 'antd';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const FilterContainerStyled = styled(Col)`
  width: 200px;
  display: inline-block;
  @media screen and (max-width: ${breakpoints.sm}) {
    max-width: 100% !important;
    width: 576px !important;
    min-width: 0 !important;
  }
  .ant-form-item {
    margin-bottom: 0;
  }
`;
